<div style="display: inline-block;">
    Tráfico
    <epy-tooltip placement="top" style="width: 18px;display: inline-block;">
        <span class="difference" slot="trigger">
            <i class="fa fa-info-circle info" aria-hidden="true"></i>
        </span>
        El índice de tráfico va de 0 a 10, donde 0 es nulo tráfico y 10 el mayor tráfico posible.
        <br>La info es tomada del tráfico de Waze y Google Maps.
    </epy-tooltip>
    - Obra
    <epy-tooltip placement="top" style="width: 18px;display: inline-block;">
        <span class="difference" slot="trigger">
            <i class="fa fa-info-circle info" aria-hidden="true"></i>
        </span>
        El índice de obra va de 0 a 1, donde 1 es que hubo una Obra, obstrucción vial o calle cerrada y 0 es que no hay.
    </epy-tooltip>
</div>
<div class="flex-item" *ngIf="reqst===2">
    <div class="graphic">
        <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
            style="width: 100%;height: 380px;display: block;overflow: hidden;"></highcharts-chart>
    </div>
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<ng-template #editModal let-modal class="modal-dialog big-dialog">
    <div class="modal-header" #tableModal>
        <h5 class="modal-title" id="downloadPricesLabel">
        </h5>
        <button type="button" class="close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding-top: 0;">
        <app-table-alerts></app-table-alerts>
    </div>
    <div class="footer-modal" style="padding-top: 0;">

    </div>
</ng-template>